import { RootState } from "../../../types/redux-types";

export const getDashboard = (state: RootState) => state.dashboard;

